<div *ngIf="!supportNullState" class="form-check form-switch" [ngClass]="classSize">
  <input class="form-check-input" [checked]="checked" [disabled]="isDisabled" (change)="toggle()" type="checkbox"
         role="switch" id="{{name}}">
  <label class="form-check-label" for="{{name}}">{{label}}</label>
</div>

<div *ngIf="!!supportNullState" class="layout-column full-height">

  <div *ngIf="checked === null" class="layout-row layout-align-start-center gap-5">
    <div class="null-state layout-column layout-align-center-center"
         (click)="toggle()">
      <div></div>
    </div>
    <span class="br-body-2">{{label}}</span>
  </div>

  <div *ngIf="checked !== null" class="form-check form-switch" [ngClass]="classSize">
    <input class="form-check-input" [checked]="checked" [disabled]="isDisabled" (change)="toggle()" type="checkbox"
         role="switch" id="{{name}}">
    <label class="form-check-label br-body-2 font-weight-400" for="{{name}}">{{label}}</label>
  </div>
</div>
